/** TODO :: Придумать название для dbs и отрефакторит */

export const recipient_form = {
  number_count: '0 numbers | {count} number | {count} numbers',
  ['include-dbs']: 'Included Databases',
  ['exclude-dbs']: 'Excluded Databases',

  field: {
    number: 'Numbers'
  },

  button: {
    add_recipients: 'Add Recipients',
    add_number: 'Add number'
  },

  tab: {
    include: {
      title: 'Include Database',
      required_format: 'Make sure the numbers in the database are in international format.'
    },

    exclude: {
      title: 'Exclude Database'
    },

    recipient: {
      title: 'Add numbers',
      description:
        'Add no more than 100 numbers to this window. Each number should be with a new line. Numbers should be in an international format.'
    }
  },

  send: {
    description: 'Newsletter will be sent to',
    cost: 'Estimated Cost {cost}',
    send: 'Send'
  }
};
